<template>
    <div>

        <v-dialog
                v-model="dialog"
                max-width="290"
        >
            <v-card>
                <v-card-title class="headline">
                    <span class=""></span>
                </v-card-title>

                <v-card-text>
                    <v-color-picker
                            :value=value
                            @input="update"
                            mode="hexa"
                            hide-inputs
                            show-swatches
                    ></v-color-picker>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                            color="primary darken-1"
                            text
                            @click="dialog = false"
                    >
                        Fechar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-btn
                xs-small
                depressed
                :color=value
                style="border: 1px gray solid"
                height="1rem"
                @click="dialog = true"
        >
            {{label}}
        </v-btn>

    </div>
</template>

<script>
    export default {
        name: "ColorPicker",
        props: {
            value: {
                type: String,
                required: false
            },

            label: {
                type: String,
                required: false
            },
        },

        data() {
            return {
                dialog: false,
            }
        },

        methods: {
            update: function (color) {
                this.$emit('input', color)
            }
        },
    }
</script>
